<template>
  <v-card flat dense>
    <v-form ref="form" v-model="valid">
      <v-card-title>
        <v-badge
          dot
          inline
          :color="smartHomeDevice.activity_last_hour ? 'primary' : 'red'"
        >
          <span class="mr-4">
            {{ $t('ITEM.EDIT') }} {{ $t('SMARTHOME_DEVICES.ITEM') }}
          </span>
        </v-badge>
        <v-spacer></v-spacer>
        <div>
          <v-btn icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <smart-home-device-sheet
              class="pa-4"
              :smart-home-device="smartHomeDevice"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-select
              v-model="smartHomeDevice.status_id"
              name="status_id"
              :items="smartHomeDeviceStatuses"
              item-value="id"
              item-text="name"
              :error-messages="errors.status"
              @change="clearErrorByName('status')"
            />
          </v-col>
        </v-row>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined depressed color="grey" @click="cancel">
            {{ $t('BUTTON.CANCEL') }}
          </v-btn>
          <v-btn depressed color="primary" :disabled="!valid" @click="update">
            {{ $t('BUTTON.UPDATE') }}
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { dateFormat } from '@/modules/_global/filters';
import { mapActions, mapState } from 'vuex';
import SmartHomeDeviceSheet from '@/modules/smarthome/components/SmartHomeDeviceSheet';

export default {
  name: 'EditSmartHomeDevice',

  filters: {
    dateFormat
  },

  components: {
    SmartHomeDeviceSheet
  },

  mixins: [errors, i18nRefreshData],

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      valid: false,
      smartHomeDevice: {}
    };
  },

  computed: {
    ...mapState('smarthome', ['smartHomeDeviceStatuses'])
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapActions('smarthome', [
      'getSmartHomeDevice',
      'getSmartHomeDeviceStatuses',
      'updateSmartHomeDevice'
    ]),
    refreshData() {
      this.getSmartHomeDevice({ id: this.id }).then(({ data }) => {
        this.smartHomeDevice = data.data;
      });
      this.getSmartHomeDeviceStatuses();
    },

    cancel() {
      this.$emit('cancel');
    },

    update() {
      this.updateSmartHomeDevice({
        id: this.id,
        smartHomeDevice: this.smartHomeDevice
      })
        .then(({ data }) => {
          this.$emit('updated', { ...data.data });
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>
